/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Parse_Csv_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to parse CSV: {error}" |
*
* @param {Knp_Terms_Parse_Csv_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_parse_csv_failed = /** @type {((inputs: Knp_Terms_Parse_Csv_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Parse_Csv_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’analyse du CSV : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Parsen der CSV-Datei: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile analizzare CSV: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось обработать CSV-файл: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al analizar CSV: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`解析 CSV 文件失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`CSV の解析に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`CSV फ़ाइल को पार्स करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao analisar o arquivo CSV: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to parse CSV: ${i?.error}`)
});